module.exports = __webpack_public_path__ + "img/dinning (2).b18c224e.jpg";